import React, { Component } from "react";
import dataProvider, { GET_LIST, DOWNLOAD_FILE, UPDATE } from "providers/dataProvider";
import ProgressBar from "components/ui_components/ProgressBar/ProgressBar";

class MdclsReportSubTable extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            reports: [],
            pdfUrl: null,
            error: null,
            issues: [],
            failCodes: [],
            mdReview: {},
            selectedFailCode: {}
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    loadData = () => {
        const reqID = this.props.row.id;

        this.setState({ loading: true, pdfUrl: null, error: null });

        Promise.all([
            dataProvider(GET_LIST, `requisitions/${reqID}/issues`, { pagination: { page: 1, perPage: 100 }, sort: { field: "id", order: "DESC" } }).catch(err => ({ data: [] })),
            dataProvider(GET_LIST, `reasons/FAIL`, { pagination: { page: 1, perPage: 100 }, sort: { field: "id", order: "DESC" } }).catch(err => ({ data: [] })),
            // dataProvider(GET_LIST, `requisitions/${reqID}/reports`, { pagination: { page: 1, perPage: 1 }, sort: { field: "id", order: "DESC" } }).catch(err => ({ data: [] }))
        ])
            .then(([issuesRes, failCodesRes, reportsRes]) => {
                if (!this._isMounted) return;

                const reportsList = reportsRes?.data || [];
                // Use the first report from the reports API, or fallback to the row's report ID logic
                const reportId = (reportsList.length > 0) ? reportsList[0].id : (this.props.row.reportId || this.props.row.repId || this.props.row.id);
                console.log(this.props.row.reportId, "this.props.row.reportId");

                this.setState({
                    issues: issuesRes?.data || [],
                    failCodes: failCodesRes?.data || [],
                    reports: reportsList,
                    loading: false
                }, () => {
                    if (this.props.tabType === "approval") {
                        // Immediately just load the view API for the report
                        this.handleDownloadClick(reportId);
                    }
                });
            })
            .catch((error) => {
                if (!this._isMounted) return;
                this.setState({
                    loading: false,
                    error: error.message || "Failed to load data.",
                });
            });
    };

    handleDownloadClick = (reportId) => {
        if (!reportId) return;
        console.log(reportId, "reportId");

        const reqID = this.props.row.id;
        this.setState({ loading: true, error: null });

        // Exactly use the requested view API 
        const resource = `requisitions/${reqID}/reports/${reportId}/view`;
        dataProvider(
            DOWNLOAD_FILE,
            resource,
            { data: { callSource: "VIEW", reportIds: [reportId] } }
        )
            .then((response) => {
                if (!this._isMounted) return;
                const url = response.data;
                if (!url || typeof url !== "string") {
                    this.setState({ loading: false, error: "Could not retrieve report URL." });
                    return;
                }
                this.setState({ loading: false, pdfUrl: url, error: null });
            })
            .catch((error) => {
                if (!this._isMounted) return;
                this.setState({
                    loading: false,
                    error: error.message || "Failed to load report.",
                });
            });
    };

    handleMdReviewChange = (issueId, value) => {
        this.setState(prevState => ({
            mdReview: {
                ...prevState.mdReview,
                [issueId]: value
            }
        }));
    };

    handleFailCodeChange = (issueId, value) => {
        this.setState(prevState => ({
            selectedFailCode: {
                ...prevState.selectedFailCode,
                [issueId]: value
            }
        }));
    };

    handleSubmitDecline = (issueId) => {
        const { selectedFailCode } = this.state;
        const reqID = this.props.row.id;
        const failCodeId = selectedFailCode[issueId];

        if (!failCodeId) {
            alert("Please select a Failcode before declining.");
            return;
        }

        dataProvider(UPDATE, `requisitions/${reqID}/fail_codes`, {
            data: { failIds: [failCodeId] }
        })
            .then(() => {
                return dataProvider(UPDATE, `requisitions`, {
                    id: reqID,
                    data: { reqStatusCode: "CLOSED" }
                });
            })
            .then(() => {
                // Also close the issue to sync state
                return dataProvider(UPDATE, `requisitions/${reqID}/issues/${issueId}`, {
                    data: { issueStatusCode: "CLOSED" }
                });
            })
            .then(() => {
                alert("Requisition has been successfully Closed with the selected Failcode.");
            })
            .catch(err => {
                alert("Failed to decline requisition: " + err.message);
            });
    };

    render() {
        const { loading, pdfUrl, error, issues, failCodes, mdReview, selectedFailCode } = this.state;

        if (loading && !issues.length && !pdfUrl) { // Adjusted condition
            return (
                <div style={{ padding: "16px", display: "flex", alignItems: "center", gap: "10px" }}>
                    <ProgressBar />
                    <span style={{ color: "#555", fontSize: "13px" }}>Loading data…</span>
                </div>
            );
        }

        const thStyle = { padding: "10px", textAlign: "left", fontSize: "13px", fontWeight: "bold", borderBottom: "1px solid #ddd" };
        const tdStyle = { padding: "10px", fontSize: "13px", borderBottom: "1px solid #eee" };

        return (
            <div style={{ padding: "20px", background: "#f5f5f5", display: "flex", flexDirection: "column" }}>
                {error && (
                    <div style={{ padding: "12px 24px", color: "#c0392b", fontSize: "13px" }}>
                        ⚠ {error}
                    </div>
                )}

                {/* Child 1: Reports List */}
                {this.props.tabType === "approval" && loading && !pdfUrl && ( // Adjusted condition
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                        <ProgressBar />
                        <span style={{ color: "#555", fontSize: "13px" }}>Loading report…</span>
                    </div>
                )}

                {this.props.tabType === "approval" && pdfUrl && !loading && (
                    <div style={{ marginBottom: "30px" }}>
                        <iframe
                            src={pdfUrl}
                            title="Requisition Report"
                            width="100%"
                            height="800px"
                            style={{ border: "1px solid #ddd", display: "block" }}
                        />
                    </div>
                )}

                {/* Child 2: Issues / MD Review */}
                {this.props.tabType === "issues" && (
                    <div>
                        <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}>
                            <thead style={{ background: "#515B61", color: "white" }}>
                                <tr>
                                    <th style={{ ...thStyle, width: "30%" }}>Issue</th>
                                    <th style={{ ...thStyle, width: "40%" }}>Note</th>
                                    <th style={{ ...thStyle, width: "30%" }}>MD Review</th>
                                </tr>
                            </thead>
                            <tbody>
                                {issues.length === 0 ? (
                                    <tr><td colSpan="3" style={{ ...tdStyle, textAlign: "center", color: "#666" }}>No issues found for this requisition</td></tr>
                                ) : (
                                    issues.map(issue => (
                                        <tr key={issue.id}>
                                            <td style={tdStyle}>{issue.issueDesc}</td>
                                            <td style={tdStyle}>{issue.issueNote}</td>
                                            <td style={tdStyle}>
                                                <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                                    <select
                                                        style={{ padding: "6px" }}
                                                        value={mdReview[issue.id] || ""}
                                                        onChange={(e) => this.handleMdReviewChange(issue.id, e.target.value)}
                                                    >
                                                        <option value="">Select...</option>
                                                        <option value="Decline">Decline</option>
                                                    </select>

                                                    {mdReview[issue.id] === "Decline" && (
                                                        <React.Fragment>
                                                            <select
                                                                style={{ padding: "6px", maxWidth: "200px" }}
                                                                value={selectedFailCode[issue.id] || ""}
                                                                onChange={(e) => this.handleFailCodeChange(issue.id, e.target.value)}
                                                            >
                                                                <option value="">Select Failcode...</option>
                                                                {failCodes.map(fc => (
                                                                    <option key={fc.id} value={fc.id}>
                                                                        {fc.failCode} - {fc.failDesc}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <button
                                                                onClick={() => this.handleSubmitDecline(issue.id)}
                                                                style={{ padding: "6px 12px", background: "#c0392b", color: "#fff", border: "none", cursor: "pointer", borderRadius: "3px" }}
                                                            >
                                                                Submit
                                                            </button>
                                                            <div style={{ color: "#c0392b", fontSize: "11px", fontStyle: "italic", width: "100%" }}>
                                                                If decline, the LIS should put associating Failcode and status should go to closed.
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}

export default MdclsReportSubTable;
